import styles from "./LCatalogTwoColsRight.module.css";

/**
 * LCatalogTwoColsRight — catalog layout 2 kolumny: main column + prawy sidebar.
 *
 * **Struktura:**
 *   (catalogContent -> belowCatalog) | rightSidebar
 */
export function LCatalogTwoColsRight({
  catalogContent,
  belowCatalog,
  rightSidebar,
}: LCatalogTwoColsRightProps) {
  return (
    <div className={styles.root}>
      <div className={styles.mainColumn}>
        <div className={styles.content}>{catalogContent}</div>
        {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
      </div>
      <aside className={styles.sidebar}>{rightSidebar}</aside>
    </div>
  );
}

export type LCatalogTwoColsRightProps = {
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
  rightSidebar: React.ReactNode;
};
